(function () {
  'use strict';

  /* Browup shade picker — rounded capsule that opens a list ("Rounded 1").
     Replaces the native "options[Color]" dropdown inside every quantity-break tier.
     File name is historical: this asset has rendered photo tiles, a segmented control
     and a dot row before this. */

  var DOTS = {
    'light brown': '#906043',
    'dark brown':  '#4A3121',
    'soft black':  '#2D2A25'
  };

  /* Brand accent, the value the theme exposes as --color-base-accent-1 (104, 81, 67).
     Hardcoded so the focus ring never falls back to transparent on a template that
     does not define the variable. */
  var ACCENT = '#685143';

  /* Order the shades appear in. The product itself is now ordered the same way, so this
     is a guard rather than a reordering: a shade the list does not know about keeps the
     order the product defines and falls to the end, so a new colour is never dropped. */
  var ORDER = ['light brown', 'dark brown', 'soft black'];

  var CSS = [
    /* The theme gives .quantity-break__selector-item width:100% AND margin-left:12px, so the
       item already sits 12px past its container's right edge and .quantity-break__variants
       clips it with overflow:hidden. Mirroring that margin on the right keeps the control
       inside the card at every width. */
    /* The theme prints its own "Color" heading above this row, which duplicated the inline
       label once the picker moved onto one line, so it is hidden. The row is content-width
       rather than 100% so it shares a line with the theme's #1 / #2 / #3 kit badge, and the
       badge is centred against it. */
    '.quantity-break__variants-heading{display:none!important}',
    '.bu-pick__num{display:flex;align-items:center;height:38px;flex:none;margin:0}',
    '.bu-pickrow{display:flex;align-items:flex-start;gap:10px;flex:0 1 auto;width:auto;max-width:100%;margin:.4rem 12px .3rem 0}',
    /* Fixed height on the label is what keeps the word Color on the same centre line as the
       capsule, and keeps it pinned to the capsule rather than drifting when the list opens. */
    '.bu-pick__cap{display:flex;align-items:center;height:38px;font-size:1.05rem;color:#7C6E62;line-height:1;flex:none}',
    '.bu-pick{display:flex;flex-direction:column;min-width:19.6rem;max-width:100%}',
    '.bu-pick__btn{display:flex;align-items:center;gap:9px;width:100%;height:38px;padding:0 14px 0 5px;',
      'background:#fff;border:1px solid #D8CEC6;border-radius:999px;cursor:pointer;text-align:left;',
      '-webkit-tap-highlight-color:transparent;transition:border-color .15s,box-shadow .15s}',
    '.bu-pick__btn[aria-expanded="true"]{border-color:' + ACCENT + ';box-shadow:0 0 0 2px rgba(104,81,67,.10)}',
    '.bu-pick__sw{width:28px;height:28px;border-radius:50%;flex:none;border:1.5px solid rgba(0,0,0,.10);',
      'box-shadow:inset 0 -3px 6px rgba(0,0,0,.13)}',
    '.bu-pick__val{font-size:1.15rem;font-weight:700;line-height:1;white-space:nowrap;color:#141212}',
    '.bu-pick__car{margin-left:auto;padding-left:8px;font-size:.9rem;line-height:1;color:#8C8078}',
    '.bu-pick__list{margin-top:6px;width:100%;background:#fff;border:1px solid #D8CEC6;border-radius:19px;',
      'box-shadow:0 8px 20px rgba(104,81,67,.14);overflow:hidden}',
    '.bu-pick__row{display:flex;align-items:center;gap:10px;width:100%;height:36px;padding:0 14px;',
      'background:none;border:0;border-radius:0;cursor:pointer;font-size:1.1rem;color:#141212;',
      'text-align:left;-webkit-tap-highlight-color:transparent}',
    '.bu-pick__row + .bu-pick__row{border-top:1px solid #F2ECE6}',
    '.bu-pick__row[aria-selected="true"]{background:#F7F1EB;font-weight:700}',
    '.bu-pick__rsw{width:20px;height:20px;border-radius:50%;flex:none;border:1.5px solid rgba(0,0,0,.10);',
      'box-shadow:inset 0 -3px 6px rgba(0,0,0,.13)}',
    '.bu-pick__name{white-space:nowrap}',
    '.bu-pick__tick{margin-left:auto;padding-left:12px;color:' + ACCENT + ';font-size:1rem;line-height:1;opacity:0}',
    '.bu-pick__row[aria-selected="true"] .bu-pick__tick{opacity:1}',
    '.bu-pick__btn:focus-visible,.bu-pick__row:focus-visible{outline:2px solid ' + ACCENT + ';outline-offset:-2px}',
    '.bu-pickrow + .select, .bu-pickrow ~ .select{display:none!important}',
    '@media (min-width:750px){.bu-pick{min-width:21rem}.bu-pick__val{font-size:1.25rem}.bu-pick__row{font-size:1.2rem;height:38px}}'
  ].join('');

  function styles() {
    if (document.getElementById('bu-pick-css')) return;
    var s = document.createElement('style');
    s.id = 'bu-pick-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function colourFor(label) {
    return DOTS[String(label).trim().toLowerCase()] || '#C9BFB3';
  }

  function rank(opt) {
    var i = ORDER.indexOf((opt.textContent || '').trim().toLowerCase());
    return i < 0 ? 99 : i;
  }

  /* Only one picker open at a time, across all six tiers. */
  var current = null;
  function closeCurrent() {
    if (current) { current(); current = null; }
  }

  var wired = false;
  function wireGlobal() {
    if (wired) return;
    wired = true;
    document.addEventListener('click', function () { closeCurrent(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeCurrent();
    });
  }

  function build(select) {
    if (!select || select.dataset.buPick === '1') return;
    select.dataset.buPick = '1';

    var row = document.createElement('div');
    row.className = 'bu-pickrow';

    var cap = document.createElement('span');
    cap.className = 'bu-pick__cap';
    cap.textContent = 'Color';

    var pick = document.createElement('div');
    pick.className = 'bu-pick';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bu-pick__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Choose your shade');

    var list = document.createElement('div');
    list.className = 'bu-pick__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    var opts = Array.prototype.slice.call(select.options);
    opts.sort(function (a, b) { return rank(a) - rank(b); });

    opts.forEach(function (opt) {
      var label = (opt.textContent || '').trim();
      var r = document.createElement('button');
      r.type = 'button';
      r.className = 'bu-pick__row';
      r.setAttribute('role', 'option');
      r.dataset.value = opt.value;
      r.innerHTML =
        '<span class="bu-pick__rsw" style="background:' + colourFor(label) + '"></span>' +
        '<span class="bu-pick__name">' + esc(label) + '</span>' +
        '<span class="bu-pick__tick" aria-hidden="true">&#10003;</span>';
      r.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        render();
        close();
        btn.focus();
      });
      list.appendChild(r);
    });

    function render() {
      var label = select.value;
      btn.innerHTML =
        '<span class="bu-pick__sw" style="background:' + colourFor(label) + '"></span>' +
        '<span class="bu-pick__val">' + esc(label) + '</span>' +
        '<span class="bu-pick__car" aria-hidden="true">' + (list.hidden ? '&#9660;' : '&#9650;') + '</span>';
      Array.prototype.forEach.call(list.querySelectorAll('.bu-pick__row'), function (r) {
        r.setAttribute('aria-selected', String(r.dataset.value === select.value));
      });
    }

    function open() {
      closeCurrent();
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      render();
      current = close;
    }

    function close() {
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      render();
      if (current === close) current = null;
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (list.hidden) open(); else close();
    });
    /* clicks inside the list must not reach the document close handler */
    list.addEventListener('click', function (e) { e.stopPropagation(); });
    select.addEventListener('change', render);

    pick.appendChild(btn);
    pick.appendChild(list);
    row.appendChild(cap);
    row.appendChild(pick);

    /* The theme's #1 / #2 / #3 kit badge is a sibling of this row, so once the list opens it
       floats to the middle of the taller line box. Moving it inside the row puts it on the
       same 38px centre line as the label and the capsule, open or closed. */
    var num = select.closest('.quantity-break__selector-item');
    num = num && num.querySelector(':scope > .quantity-break__selector-item__number');
    if (num) { num.classList.add('bu-pick__num'); row.insertBefore(num, row.firstChild); }

    var holder = select.closest('.select') || select;
    if (holder.parentNode) holder.parentNode.insertBefore(row, holder);
    holder.style.display = 'none';
    render();
  }

  var busy = false;
  function scan() {
    if (busy) return;
    busy = true;
    try {
      styles();
      wireGlobal();
      Array.prototype.forEach.call(
        document.querySelectorAll('.quantity-breaks-container select[name="options[Color]"]'),
        build
      );
    } catch (e) { /* never break the buy box */ }
    busy = false;
  }

  function boot() {
    scan();
    var host = document.querySelector('.quantity-breaks-container');
    if (!host || host.dataset.buPickObs === '1') return;
    host.dataset.buPickObs = '1';
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(scan, 80);
    }).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
